import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatStepper, MatHorizontalStepper, MatStep } from '@angular/material';
import { GlobalConstants } from 'src/app/shared/constants/global-constants';
import { ClientModel } from 'src/app/shared/models/client.model';
import { RmaRequestModel } from 'src/app/shared/models/rma.model';
@Component({
  selector: 'app-find-rma-customer-step',
  templateUrl: './find-rma-customer-step.component.html',
  styleUrls: ['./find-rma-customer-step.component.css']
})
export class FindRmaCustomerStepComponent implements OnInit {
  @Input() rmarequest : RmaRequestModel;
  @Input() mystep : MatStep;
  @Output() onNextStep: EventEmitter<any> = new EventEmitter<any>();
  showCustomerList : boolean;
  selectedCustomer : ClientModel;
  userTypeList : string [];
  rmaTypeList : string[];
  destinationList : string [];

  constructor() {
    this.userTypeList = GlobalConstants.constUserTypeArray;
    this.destinationList = GlobalConstants.constCountryArray;
  }

  ngOnInit() {
    this.selectedCustomer = null;
    this.showCustomerList = true;

    if(GlobalConstants.isClientDealer(this.rmarequest.rma.clientType))
    {
      this.rmaTypeList = GlobalConstants.constRmaTypeArrayForDealer;
    }
    else
    {
      this.rmaTypeList = GlobalConstants.constRmaTypeArrayForClient;
    }
  }

  onUserTypeChangeAction(data)
  {
    // var value = this.form.get('issueCategoryId').value;
    console.log("onWarrantyChangeAction : " + data.source.selected.viewValue);
    if(GlobalConstants.isClientDealer( data.source.selected.value))
    {
      this.rmaTypeList = GlobalConstants.constRmaTypeArrayForDealer;
    }
    else
    {
      this.rmaTypeList = GlobalConstants.constRmaTypeArrayForClient;
    }
  }

  getCountryString(code)
  {
    return GlobalConstants.getCountryString(code);
  }

  getCustomerString(type)
  {
    return GlobalConstants.getCustomerString(type);
  }

  getRmaTypeString(type)
  {
    return GlobalConstants.getRmaTypeString(type);
  }
  onNext()
  {
    this.rmarequest.rma.clientId = this.selectedCustomer.clientId;
    this.rmarequest.client = this.selectedCustomer;
    this.rmarequest.rma.emailRequested = (this.rmarequest.rma.emailRequestedString == "1");
    this.onNextStep.emit(this.rmarequest);
  }
  onFindCustomer()
  {
    this.selectedCustomer = null;
    this.showCustomerList = true;

  }
  afterSelected(data : any)
  {
    console.log("afterSelected");
    this.selectedCustomer = data as ClientModel;
    this.showCustomerList = false;
  }
}
